import React from "react";
import cx from "classnames";

import styles from "./siteSettings.module.scss";

const COLUMN_1_HEIGHTS = [223, 187, 383, 336];
const COLUMN_2_HEIGHTS = [217, 147, 147, 103, 311];
const HERO_HEIGHT = 170;
const FULL_WIDTH_HEIGHT = 260;

interface SkeletonBlockProps {
  height: number;
}

const SkeletonBlock: React.FC<SkeletonBlockProps> = ({ height }) => (
  <div
    className={cx(styles.skeletonBlock, styles.shimmer)}
    style={{ height }}
  />
);

const SiteSettingsSkeleton: React.FC = () => (
  <div className={styles.grid}>
    <div className={styles.fullWidth}>
      <SkeletonBlock height={HERO_HEIGHT} />
    </div>
    <div className={styles.column}>
      {COLUMN_1_HEIGHTS.map((h, i) => (
        <SkeletonBlock key={`c1-${i}`} height={h} />
      ))}
    </div>
    <div className={styles.column}>
      {COLUMN_2_HEIGHTS.map((h, i) => (
        <SkeletonBlock key={`c2-${i}`} height={h} />
      ))}
    </div>
    <div className={styles.fullWidth}>
      <SkeletonBlock height={FULL_WIDTH_HEIGHT} />
    </div>
  </div>
);

export default SiteSettingsSkeleton;
